import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withConsumptionsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
